// extracted by mini-css-extract-plugin
export default {"headingText":"HeadingText_headingText__h4wiY"};